import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MemberSignIn from "routes/account/signIn/MemberSignIn";
import MobileSignIn from "routes/account/signIn/MobileSignIn";
import MobileMypage from "routes/front/main/vending/MobileMypage";
import qrcodeIcon from "resources/img/puffu/qrcodeIcon.png";
import mypageIcon from "resources/img/puffu/mypage.png";

function MobileHome() {
    const { userId, userName } = useContext(AuthContext);
    const navigate = useNavigate();
    //회원가입 도ㅒㅆ는지
    // 로그인 됐는지 확인
    return (
        <MobileMypage />
    );
}

export default MobileHome;